module.exports = __webpack_public_path__ + "img/nothing-found.f5b56dc4.gif";